import * as types from "../constants";
import { LoadCompanyLogoResult } from "../../Interfaces/Interfaces";

export function UpdateCompanySettings(CompanySettings: LoadCompanyLogoResult): types.UpdateCompanySettings {
    return {
        type: types.UPDATE_COMPANY_SETTINGS,
        payload: CompanySettings
    };
}
